import React, {
  createContext,
  ReactNode,
  useContext,
  useMemo,
  useState,
} from "react";

import {
  Masters,
  MastersAgent,
  MastersChannelPartner,
  MastersChapter,
  MastersConcierge,
  MastersDevelopment,
  MastersEventsAndExperience,
  MastersHomeAcquisition,
  MastersRental,
  MastersSolene,
} from "../types/masters";

export type MastersState = {
  masters: Masters;
  updateMasters: (masters: Masters) => any;
  mastersRental: MastersRental;
  updateMastersRental: (mastersRental: MastersRental) => any;
  mastersDevelopment: MastersDevelopment;
  updateMastersDevelopment: (mastersDevelopment: MastersDevelopment) => any;
  mastersChapter: MastersChapter;
  updateMastersChapter: (mastersChapter: MastersChapter) => any;
  mastersHA: MastersHomeAcquisition;
  updateMastersHA: (mastersHA: MastersHomeAcquisition) => any;
  mastersAgent: MastersAgent;
  updateMastersAgent: (mastersAgent: MastersAgent) => any;
  mastersChannelPartner: MastersChannelPartner;
  updateMastersChannelPartner: (mastersChannelPartner: MastersChannelPartner) => any;
  mastersConcierge: MastersConcierge;
  updateMastersConcierge: (mastersConcierge: MastersConcierge) => any;
  mastersEventsAndExperience: MastersEventsAndExperience;
  updateMastersEventsAndExperience: (
    mastersEventsAndExperience: MastersEventsAndExperience,
  ) => any;
  mastersSolene: MastersSolene;
  updateMastersSolene: (mastersSolene: MastersSolene) => any;
};

const DEFAULT_MASTERS: Masters = {
    contact_genders: [],
    call_types: [],
    contact_gendersMap: {},
    contact_marital_status: [],
    contact_marital_statusMap: {},
    enquiry_interested_in: [],
    enquiry_interested_inMap: {},
    enquiry_verticals: [],
    enquiry_verticalsMap: {},
    staff_roles: [],
    staff_rolesMap: {},
    staff_verticals: [],
    staff_verticalsMap: {},
    opportunity_status: [],
    opportunity_statusMap: {},
    locations: [],
    locationsMap: {},
    sources: {},
    source_regions: [],
    source_regionsMap: {},
    document_types: [],
    document_typesMap: {},
    relations: [],
    relationsMap: {},
    agent_types: [],
    agent_typesMap: {},
    calling_numbers: [],
    calling_numbersMap: {},
    india_states: [],
    india_statesMap: {},
    brands: [],
    brandsMap: {},
    departments: [],
    departmentsMap: {},
    service_types: [],
    service_typesMap: {},
    site_visit_statuses: [],
    site_visit_statusesMap: {},
    site_visit_cancellation_reasons: [],
    site_visit_cancellation_reasonsMap: {},
    site_visit_plot_verticals: [],
    site_visit_plot_verticalsMap: {},
    domestic_properties: [],
    domestic_propertiesMap: {},
  },
  DEFAULT_MASTERS_RENTAL: MastersRental = {
    visit_purpose: [],
    visit_purposeMap: {},
    cleartax_cancellation_reasons: [],
    cleartax_cancellation_reasonsMap: {},
    invoice_rejection_reasons: [],
    invoice_rejection_reasonsMap: {},
    invoice_status: [],
    invoice_statusMap: {},
    invoice_types: [],
    invoice_typesMap: {},
    opportunity_status: [],
    opportunity_statusMap: {},
    locations: [],
    locationsMap: {},
    stringified_locations: [],
    countries: [],
    countriesMap: {},
    coupon_types: [],
    coupon_typesMap: {},
    property_types: [],
    property_typesMap: {},
    medium: [],
    mediumMap: {},
    closed_reason: [],
    closed_reasonMap: {},
    lead_closed_reason: [],
    lead_closed_reasonMap: {},
    prospect_closed_reason: [],
    prospect_closed_reasonMap: {},
    stages: [],
    stagesMap: {},
    properties: [],
    propertiesMap: {},
    prebooking_durations: [],
    prebooking_durationsMap: {},
    offer_types: [],
    offer_typesMap: {},
    attachment_types: [],
    attachment_typesMap: {},
    charge_types: [],
    payment_modes: [],
    payment_modesMap: {},
    payment_types: [],
    payment_typesMap: {},
    charge_typesMap: {},
    domestic_locations: [],
    domestic_locationsMap: {},
    contract_licence_types: [],
    contract_licence_typesMap: {},
    queries: [],
    queriesMap: {},
    bad_stay_accounts: [],
    bad_stay_accountsMap: {},
    bad_stay_reasons: [],
    bad_stay_reasonsMap: {},
    payment_rejection_reasons: [],
    payment_rejection_reasonsMap: {},
    currencies: [],
    currenciesMap: {},
    payment_status: [],
    payment_statusMap: {},
    deposit_pending_reasons: [],
    deposit_pending_reasonsMap: {},
    deposit_status: [],
    deposit_statusMap: {},
    categories: [],
    categoriesMap: {},
    resort_properties: [],
    resort_propertiesMap: {},
    international_payment_types: [],
    international_payment_typesMap: {},
    agent_for_options: [],
    agent_for_optionsMap: {},
    payment_for_options: [],
    payment_for_optionsMap: {},
    international_payment_for_options: [],
    international_payment_for_optionsMap: {},
    charge_statuses: [],
    charge_statusesMap: {},
    cancellation_reasons: [],
    cancellation_reasonsMap: {},
    property_highlights: [],
    property_highlightsMap: {},
    agent_payment_types: [],
    agent_payment_typesMap: {},
    calendar_years: [],
    calendar_yearsMap: {},
    sales_channels: [],
    sales_channelsMap: {},
    reason_for_allocation: [],
    reason_for_allocationMap: {},
    calendar_status: [],
    calendar_statusMap: {},
    charge_master_categories: [],
    charge_master_categoriesMap: {},
    food_types: [],
    food_typesMap: {},
    meal_preferences: [],
    meal_preferencesMap: {},
    cc_reservation_ivpl_departments: [],
    cc_reservation_ivpl_departmentsMap: {},
    cc_reservation_ihpl_departments: [],
    cc_reservation_ihpl_departmentsMap: {},
    cc_charge_ivpl_departments: [],
    cc_charge_ivpl_departmentsMap: {},
    cc_charge_ihpl_departments: [],
    cc_charge_ihpl_departmentsMap: {},
    hom_task_status: [],
    hom_task_statusMap: {},
    hom_task_medium: [],
    hom_task_mediumMap: {},
    hom_task_types: [],
    hom_task_typesMap: {},
    homeowner_approval_categories: [],
    homeowner_approval_categoriesMap: {},
    rental_collabs: [],
    rental_collabsMap: {},
    agent_and_commission_sources: {
      "4_fields": [],
      "2_fields": [],
    },
  },
  DEFAULT_MASTERS_DEVELOPMENT: MastersDevelopment = {
    opportunity_status: [],
    opportunity_statusMap: {},
    medium: [],
    mediumMap: {},
    closed_reason: [],
    closed_reasonMap: {},
    stages: [],
    stagesMap: {},
    locations: [],
    stringified_locations: [],
    delivery_timeline_status: [],
    milestones: [],
    poc_list: [],
    properties: [],
    properties_with_include_in_reports: [],
    agreement_types: [],
    collection_entity: [],
    account_type: [],
    bank_accounts: [],
    bank_accountsMap: {},
    document_types: [],
    document_typesMap: {},
    attachment_types: [],
    attachment_typesMap: {},
    gst_value: [],
    gst_valueMap: {},
    tds_value: [],
    tds_valueMap: {},
    viewing_types: [],
    viewing_typesMap: {},
    sub_phase_types: [],
    sub_phase_typesMap: {},
    backout_reasons: [],
    refund_reasons: [],
    refund_reasonsMap: {},
    change_request_backout_reasons: [],
    change_request_backout_reasonsMap: {},
    property_types: [],
    property_typesMap: {},
    home_statuses: [],
    home_statusesMap: {},
    project_budget_ranges: [],
    project_budget_rangesMap: {},
  },
  DEFAULT_MASTERS_CHAPTER: MastersChapter = {
    opportunity_status: [],
    opportunity_statusMap: {},
    home_layouts: [],
    home_layoutsMap: {},
    stages: [],
    stagesMap: {},
    medium: [],
    mediumMap: {},
    closed_reason: [],
    closed_reasonMap: {},
    plots: [],
    plotsMap: {},
    properties: [],
    properties_with_include_in_reports: [],
    bank_accounts: [],
    bank_accountsMap: {},
    gst_value: [],
    gst_valueMap: {},
    tds_value: [],
    tds_valueMap: {},
    agreement_types: [],
    agreement_typesMap: {},
    attachment_types: [],
    attachment_typesMap: {},
    locations: [],
    locationsMap: {},
    stringified_locations: [],
    delivery_timeline_status: [],
    milestones: [],
    delivery_timeline_statusMap: {},
    document_types: [],
    document_typesMap: {},
    viewing_types: [],
    viewing_typesMap: {},
    sub_phase_types: [],
    sub_phase_typesMap: {},
    backout_reasons: [],
    refund_reasons: [],
    refund_reasonsMap: {},
    change_request_backout_reasons: [],
    change_request_backout_reasonsMap: {},
    property_types: [],
    property_typesMap: {},
    home_statuses: [],
    home_statusesMap: {},
    project_budget_ranges: [],
    project_budget_rangesMap: {},
  },
  DEFAULT_MASTERS_HA: MastersHomeAcquisition = {
    opportunity_status: [],
    opportunity_statusMap: {},
    locations: [],
    locationsMap: {},
    medium: [],
    mediumMap: {},
    closed_reason: [],
    closed_reasonMap: {},
    lead_closed_reason: [],
    lead_closed_reasonMap: {},
    prospect_closed_reason: [],
    prospect_closed_reasonMap: {},
    stages: [],
    stagesMap: {},
    inactive_reasons: [],
    hold_reason: [],
    inactive_reasonsMap: {},
    hold_reasonMap: {},
  },
  DEFAULT_MASTERS_AGENT: MastersAgent = {
    opportunity_status: [],
    opportunity_statusMap: {},
    closed_reason: [],
    closed_reasonMap: {},
    attachment_types: [],
    attachment_typesnMap: {},
    medium: [],
    mediumMap: {},
    sources: [],
    sourcesMap: {},
  },
  DEFAULT_MASTERS_CHANNEL_PARTNER: MastersChannelPartner = {
    ratings: [],
    ratingsMap: {},
    agent_categories: [],
    agent_categoriesMap: {},
    agent_tiers: [],
    agent_tiersMap: {},
    lead_stages: [],
    lead_stagesMap: {},
    medium: [],
    mediumMap: {},
    budgets: [],
    budgetsMap: {},
    purposes: [],
    purposesMap: {},
    brands: [],
    brandsMap: {},
  },
  DEFAULT_MASTERS_CONCIERGE = {
    ticket_status: [],
    ticket_statusMap: {},
    priorities: [],
    prioritiesMap: {},
    departments: [],
    departmentsMap: {},
    ticket_sort_options: [],
    ticket_sort_optionsMap: {},
    service_types: [],
    service_typesMap: {},
    expense_statuses: [],
    expense_statusesMap: {},
    expense_types: [],
    expense_typesMap: {},
    properties: [],
    propertiesMap: {},
    verticals: [],
    ticket_types: [],
    ticket_typesMap: {},
    gst_percentage: [],
    gst_percentageMap: {},
    clusters: [],
    ops_departments: [],
    ops_departmentsMap: {},
    locations: [],
    locationsMap: {},
    reason: { close: [], hold: [], reopen: [] },
    due_date_max_days: { ticket: 15, incident: 1 },
  },
  DEFAULT_MASTERS_EVENTS_AND_EXPERIENCE: MastersEventsAndExperience = {
    opportunity_status: [],
    opportunity_statusMap: {},
    locations: [],
    locationsMap: {},
    medium: [],
    mediumMap: {},
    closed_reason: [],
    closed_reasonMap: {},
    stages: [],
    stagesMap: {},
    event_type: [],
    event_typeMap: {},
    lead_closed_reason: [],
    lead_closed_reasonMap: {},
    prospect_closed_reason: [],
    prospect_closed_reasonMap: {},
  },
  DEFAULT_MASTERS_SOLENE: MastersSolene = {
    opportunity_status: [],
    opportunity_statusMap: {},
    medium: [],
    mediumMap: {},
    closed_reason: [],
    closed_reasonMap: {},
    lead_closed_reason: [],
    lead_closed_reasonMap: {},
    prospect_closed_reason: [],
    prospect_closed_reasonMap: {},
    stages: [],
    stagesMap: {},
    payment_for_options: [],
    payment_for_optionsMap: {},
    payment_types: [],
    payment_typesMap: {},
    payment_rejection_reasons: [],
    payment_rejection_reasonsMap: {},
    currencies: [],
    currenciesMap: {},
    membership_plans: [],
    membership_plansMap: {},
    membership_profile_types: [],
    membership_profile_typesMap: {},
    attachment_types: [],
    attachment_typesMap: {},
  },
  DEFAULT_MASTERS_STATE = {
    masters: DEFAULT_MASTERS,
    updateMasters: () => null,
    mastersRental: DEFAULT_MASTERS_RENTAL,
    updateMastersRental: () => null,
    mastersDevelopment: DEFAULT_MASTERS_DEVELOPMENT,
    updateMastersDevelopment: () => null,
    mastersChapter: DEFAULT_MASTERS_CHAPTER,
    updateMastersChapter: () => null,
    mastersHA: DEFAULT_MASTERS_HA,
    updateMastersHA: () => null,
    mastersAgent: DEFAULT_MASTERS_AGENT,
    updateMastersAgent: () => null,
    mastersChannelPartner: DEFAULT_MASTERS_CHANNEL_PARTNER,
    updateMastersChannelPartner: () => null,
    mastersConcierge: DEFAULT_MASTERS_CONCIERGE,
    updateMastersConcierge: () => null,
    mastersEventsAndExperience: DEFAULT_MASTERS_EVENTS_AND_EXPERIENCE,
    updateMastersEventsAndExperience: () => null,
    mastersSolene: DEFAULT_MASTERS_SOLENE,
    updateMastersSolene: () => null,
  };

const MastersContext = createContext<MastersState>(DEFAULT_MASTERS_STATE);

interface MastersProviderProps {
  children: ReactNode;
}

function MastersProvider(props: MastersProviderProps) {
  const { children } = props,
    [masters, updateMasters] = useState<Masters>(DEFAULT_MASTERS),
    [mastersRental, updateMastersRental] = useState<MastersRental>(
      DEFAULT_MASTERS_RENTAL,
    ),
    [mastersDevelopment, updateMastersDevelopment] =
      useState<MastersDevelopment>(DEFAULT_MASTERS_DEVELOPMENT),
    [mastersChapter, updateMastersChapter] = useState<MastersChapter>(
      DEFAULT_MASTERS_CHAPTER,
    ),
    [mastersHA, updateMastersHA] =
      useState<MastersHomeAcquisition>(DEFAULT_MASTERS_HA),
    [mastersAgent, updateMastersAgent] = useState<MastersAgent>(
      DEFAULT_MASTERS_AGENT,
    ),
    [mastersChannelPartner, updateMastersChannelPartner] = useState<MastersChannelPartner>(
      DEFAULT_MASTERS_CHANNEL_PARTNER,
    ),
    [mastersConcierge, updateMastersConcierge] = useState<MastersConcierge>(
      DEFAULT_MASTERS_CONCIERGE,
    ),
    [mastersEventsAndExperience, updateMastersEventsAndExperience] =
      useState<MastersEventsAndExperience>(
        DEFAULT_MASTERS_EVENTS_AND_EXPERIENCE,
      ),
    [mastersSolene, updateMastersSolene] = useState<MastersSolene>(
      DEFAULT_MASTERS_SOLENE,
    ),
    onUpdateMasters = (masters: Masters) => {
      updateMasters(masters);
    },
    onUpdateMastersRental = (mastersRental: MastersRental) => {
      updateMastersRental(mastersRental);
    },
    onUpdateMastersDevelopment = (mastersDevelopment: MastersDevelopment) => {
      updateMastersDevelopment(mastersDevelopment);
    },
    onUpdateMastersChapter = (mastersChapter: MastersChapter) => {
      updateMastersChapter(mastersChapter);
    },
    onUpdateMastersHA = (mastersHA: MastersHomeAcquisition) => {
      updateMastersHA(mastersHA);
    },
    onUpdateMastersAgent = (mastersAgent: MastersAgent) => {
      updateMastersAgent(mastersAgent);
    },
    onUpdateMastersChannelPartner = (mastersChannelPartner: MastersChannelPartner) => {
      updateMastersChannelPartner(mastersChannelPartner);
    },
    onUpdateMastersConcierge = (mastersConcierge: MastersConcierge) => {
      updateMastersConcierge(mastersConcierge);
    },
    onUpdateMastersEventsAndExperience = (
      mastersEventsAndExperience: MastersEventsAndExperience,
    ) => {
      updateMastersEventsAndExperience(mastersEventsAndExperience);
    },
    onUpdateMastersSolene = (mastersSolene: MastersSolene) => {
      updateMastersSolene(mastersSolene);
    },
    value = useMemo(
      () => ({
        masters: masters,
        updateMasters: onUpdateMasters,
        mastersRental: mastersRental,
        updateMastersRental: onUpdateMastersRental,
        mastersDevelopment: mastersDevelopment,
        updateMastersDevelopment: onUpdateMastersDevelopment,
        mastersChapter: mastersChapter,
        updateMastersChapter: onUpdateMastersChapter,
        mastersHA: mastersHA,
        updateMastersHA: onUpdateMastersHA,
        mastersAgent: mastersAgent,
        updateMastersAgent: onUpdateMastersAgent,
        mastersChannelPartner: mastersChannelPartner,
        updateMastersChannelPartner: onUpdateMastersChannelPartner,
        mastersConcierge: mastersConcierge,
        updateMastersConcierge: onUpdateMastersConcierge,
        mastersEventsAndExperience: mastersEventsAndExperience,
        updateMastersEventsAndExperience: onUpdateMastersEventsAndExperience,
        mastersSolene: mastersSolene,
        updateMastersSolene: onUpdateMastersSolene,
      }),
      [
        masters,
        mastersRental,
        mastersDevelopment,
        mastersChapter,
        mastersHA,
        mastersChannelPartner,
        mastersConcierge,
        mastersEventsAndExperience,
        mastersSolene,
      ],
    );

  return (
    <MastersContext.Provider value={value}>{children}</MastersContext.Provider>
  );
}

function useMasters() {
  return useContext(MastersContext);
}

export { MastersProvider, useMasters };
